import { observable, action, useStrict } from 'mobx';
import resultListStore from './resultListStore';
import bannerTopStore from './bannerTopStore';
const querystring = require('querystring');

useStrict(true);

class CheckListStore {
  @observable labels
  @observable isShowCheckList

  constructor() {
    this.params = querystring.parse(window.location.search.slice(1));
    this.labels = {
      suffixs: this.params.suffix ? this.params.suffix.slice(1) : ' ',
      types: this.params.constitute ? this.params.constitute : ' ',
      length: this.params.length ? this.params.length : ' ',
      numbers: ' '
    };
    this.isShowCheckList = false;
    this.labelTags = {
      suffixs: '后缀',
      types: '分类',
      length: '长度',
      numbers: '价格'
    };
    this.suffixs = window.searchSurffix || [
      { text: '.xin', value: 'xin' },
      { text: '.top', value: 'top' },
      { text: '.vip', value: 'vip' },
      { text: '.wang', value: 'wang' },
      { text: '.club', value: 'club' },
      { text: '.ltd', value: 'ltd' },
      { text: '.group', value: 'group' },
      { text: '.我爱你', value: '我爱你' },
      { text: '.ren', value: 'ren' },
      { text: '.link', value: 'link' },
      { text: '.kim', value: 'kim' },
      { text: '.shop', value: 'shop' },
      { text: '.xyz', value: 'xyz' }
    ];
    this.types = window.searchType || [
      { text: '数字', value: 11 },
      { text: '字母', value: 12 },
      { text: '单词', value: 16 },
      { text: '拼音', value: 15 }
    ];
    this.length = window.searchLength || [
      { text: '1个', value: 1 },
      { text: '2个', value: 2 },
      { text: '3个', value: 3 },
      { text: '4个', value: 4 }
    ];
    this.numbers = window.searchPrice || [
      { text: '0-200', value: '0,200' },
      { text: '200-1000', value: '200,1000' },
      { text: '1000-5000', value: '1000,5000' },
      { text: '5000-10000', value: '5000,10000' }
    ];
    this.labelObj = {
      suffixs: this.suffixs,
      types: this.types,
      length: this.length,
      numbers: this.numbers
    };
    for (let key in this.labelObj) {
      this.labelObj[key].unshift({ text: '不限', value: ' ' });
    }
  }

  @action
  handlerChangeCheck(name, event) {
    this.labels[name] = event.target.value;
    switch (name) {
      case 'suffixs':
        resultListStore.fetchresultList({
          keyWord: bannerTopStore.inputDomain,
          suffix: this.labels[name]
        });
        break;
      case 'types':
        resultListStore.fetchresultList({
          constitute: this.labels[name]
        });
        break;
      case 'length':
        resultListStore.fetchresultList({
          minLength: this.labels[name],
          maxLength: this.labels[name]
        });
        break;
      case 'numbers':
        resultListStore.fetchresultList({
          minPrice: this.labels[name].split(',')[0],
          maxPrice: this.labels[name].split(',')[1]
        });
        break;
      default:
        resultListStore.fetchresultList();
    }
  }

  @action
  handlerShowCheckList() {
    this.isShowCheckList = !this.isShowCheckList;
  }

  @action
  handlerCleanCheck() {
    for (let key in this.labels) {
      this.labels[key] = ' ';
    }
  }

  @action
  handlerChangeCheckSuffix(suffix) {
    this.labels.suffixs = suffix;
  }

}

export default new CheckListStore;


// WEBPACK FOOTER //
// ./src/store/checkListStore.js